import {EditedParticipation} from '../../../Partner/EditedPartner';
import {CommunityPlantedDBHContent} from '../../ParticipationColumns/CommunityEvents/CommunityPlantedDBH';
import {CommunityTreesPlantedContent} from '../../ParticipationColumns/CommunityEvents/CommunityTreesPlanted';
import {ProjectCommunityTreesPlantedContent} from '../../ParticipationColumns/CommunityEvents/ProjectCommunityTreesPlanted';
import {DAMTagContent} from '../../ParticipationColumns/Shared/DAMTag';
import {DeleteParticipationContent} from '../../ParticipationColumns/Shared/DeleteParticipation';
import {EverythingValidatedContent} from '../../ParticipationColumns/Shared/EverythingValidated';
import {ProposalContent} from '../../ParticipationColumns/Shared/ProposalColumn';
import {DemoProjectContent} from '../../ParticipationColumns/Shared/DemoProjectColumn';
import {ExcludedContent} from '../../ParticipationColumns/Shared/Excluded';
import {FundedYearContent} from '../../ParticipationColumns/Shared/FundedYear';
import {HasHeroContent} from '../../ParticipationColumns/Shared/HasHero';
import {HasTreeSpeciesContent} from '../../ParticipationColumns/Shared/HasTreeSpecies';
import {ImageCountContent} from '../../ParticipationColumns/Shared/ImageCount';
import {ImagesValidatedContent} from '../../ParticipationColumns/Shared/ImagesValidated';
import {ImpactStoryCompletedContent} from '../../ParticipationColumns/Shared/ImpactStoryCompleted';
import {ImpactStoryInProgressContent} from '../../ParticipationColumns/Shared/ImpactStoryInProgress';
import {MapContent} from '../../ParticipationColumns/Shared/Map';
import {ParticipationIdContent} from '../../ParticipationColumns/Shared/ParticipationId';
import {PlantingPartnerContent} from '../../ParticipationColumns/Shared/PlantingPartner';
import {ProjectIdContent} from '../../ParticipationColumns/Shared/ProjectId';
import {ProjectLocationContent} from '../../ParticipationColumns/Shared/ProjectLocation';
import {ProjectNameContent} from '../../ParticipationColumns/Shared/ProjectName';
import {ProjectStatusContent} from '../../ParticipationColumns/Shared/ProjectStatus';
import {ProjectTypeContent} from '../../ParticipationColumns/Shared/ProjectTypeColumn';
import {ReasonForPlantingContent} from '../../ParticipationColumns/Shared/ReasonForPlanting';
import {ShowOnDateContent} from '../../ParticipationColumns/Shared/ShowOnDate';
import {
    ParticipationRemover,
    ParticipationUnremover,
    ParticipationUpdater,
    ProjectSelectionSetter
} from '../../ParticipationFunctions/ParticipationModifications';
import { ProjectYearsContent } from '../../ParticipationColumns/Shared/ProjectYears';
import {VisibleToParticipantContent} from '../../ParticipationColumns/Shared/VisibleToParticipant';

export function MembershipTreesContent({
    role,
    participation,
    remover,
    unremover,
    updater,
    projectSelectionSetter,
    imageData
}: {
    role: string[];
    participation: EditedParticipation;
    remover: ParticipationRemover;
    unremover: ParticipationUnremover;
    updater: ParticipationUpdater;
    projectSelectionSetter: ProjectSelectionSetter;
    imageData: {hasHero: boolean; imageCount: number};
}) {
    return (
        <tr>
            <DeleteParticipationContent
                ppn={participation}
                remover={remover}
                unremover={unremover}
                role={role}
            />
            <ExcludedContent ppn={participation} updater={updater} />
            <EverythingValidatedContent ppn={participation} />
            <ProposalContent ppn={participation} />
            <DemoProjectContent ppn={participation} />
            <VisibleToParticipantContent ppn={participation} />
            <ParticipationIdContent ppn={participation} />
            <FundedYearContent ppn={participation} updater={updater} />
            <CommunityTreesPlantedContent ppn={participation} updater={updater} />
            <ShowOnDateContent ppn={participation} updater={updater} />
            <ProjectIdContent ppn={participation} projectSelectionSetter={projectSelectionSetter} />
            <ProjectTypeContent ppn={participation} />
            <ProjectNameContent ppn={participation} />
            <ProjectStatusContent ppn={participation} />
            <ProjectLocationContent ppn={participation} />
            <MapContent ppn={participation} />
            <ProjectYearsContent ppn={participation} />
            <ReasonForPlantingContent ppn={participation} />
            <ImpactStoryInProgressContent ppn={participation} />
            <ImpactStoryCompletedContent ppn={participation} />
            <PlantingPartnerContent ppn={participation} />
            <ProjectCommunityTreesPlantedContent ppn={participation} />
            <CommunityPlantedDBHContent ppn={participation} />
            <HasTreeSpeciesContent ppn={participation} />
            <DAMTagContent ppn={participation} />
            <ImagesValidatedContent ppn={participation} />
            <ImageCountContent ppn={participation} imageCount={imageData.imageCount} />
            <HasHeroContent ppn={participation} hasHero={imageData.hasHero} />
        </tr>
    );
}
